import _ from 'lodash';
import React from 'react';
import PropTypes, { element } from 'prop-types';
import update from 'react-addons-update';
import {push} from 'react-router-redux';
import Radium from 'radium';

import * as styles from '../../styles';
import {imageUrl} from '../../utilities/requests';
import {request} from '../../containers/actions';

//@Radium
export default class Mark extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    state = {
        assignedScores: {},
        mode: 1,
        seleced_id : 0
    }

    componentDidMount() { 
        this.userSelect = document.body.style.userSelect;
        document.body.style.userSelect = 'none';
        if (this.props.answerId || this.props.id)
            this.fetch.bind(this)();
        else
            this.next.bind(this)();
    }

    componentWillUnmount() {

        
        document.body.style.userSelect = this.userSelect;
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    }

    componentDidUpdate(prevProps) {
        
        if (
            this.props.answerId && this.props.answerId !== prevProps.answerId ||
            this.props.id && this.props.id !== prevProps.id
        )
            this.fetch.bind(this)();
    }
    async getAllResult(){    
        const response = await this.context.store.dispatch(request({
            path: `/answer/${this.state.answer.id}/get_Result/`,
        }));
        var all_resutl=response;
        this.setState({all_resutl}); 
    }
    async getComment(){    
        // debugger;
        const response = await this.context.store.dispatch(request({
            path: `/getComment/`,
            body: {answerId: this.state.answer.id},
        }));        
        var comment=response.res;
        var commentId = response.resId;
        this.setState({comment,commentId}); 
    }
    async changeCommentStatus(){
        // debugger;
        var test = this.state.commentId;
        const response = await this.context.store.dispatch(request({
            path: `/SetMark/`,
            body: {commentId: this.state.commentId},
        })); 
    }
    setOldScore(scores,id){
        // debugger; 
        if(id === this.state.seleced_id){

            this.setState({
                assignedScores : {},
                seleced_id:0
            });
        }
        else{
            this.setState({
                assignedScores : scores,
                seleced_id:id
            });
        }
    }
 
    async fetch() {
        
        this.setState({fetching: true});
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer =  null;
        }
        if (this.props.answerId) {
            const response = await this.context.store.dispatch(request({
                path: `/answer/${this.props.answerId}/`,
            }));
            this.setState({
                answer: response,
                fetching: false,
            });
            this.getAllResult();
            this.getComment();
        }
        else if (this.props.id) {
            const response = await this.context.store.dispatch(request({
                path: `/result/${this.props.id}/`,
            }));
            this.setState({
                result: response,
                answer: response.answer,
                assignedScores: response.scores, 
                fetching: false,
            });
            this.getAllResult();
            this.getComment();
        }
    }

    timedOut() {
        // const path = this.context.store.getState().getIn(['routing', 'locationBeforeTransitions', 'pathname']);
        // this.context.store.dispatch(push(path.split('/').slice(0, -2).join('/') + '/'));
    }

    async next() {
        
        var date = Date.now();  
        this.setState({fetching: true});
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }   
        if (this.props.answerId || this.props.id) {
            const path = this.context.store.getState().getIn(
                ['routing', 'locationBeforeTransitions', 'pathname'],
            );
            this.context.store.dispatch(push(path.split('/').slice(0, -2).join('/') + '/'));
            return;
        }
        const response = await this.context.store.dispatch(request({
            path: '/answer/next/?question=' + this.props.questionId+'&uid='+date,
        }));
        if(response!==null){
            const answer = response[0];
            const reserved = response[1];
            this.timer = setTimeout(this.timedOut.bind(this), Math.max(answer.required_time * 1000 * 3, 120));
            this.setState({ answer, reserved, fetching: false });
            this.getAllResult(); 
            this.getComment();
        }
        else{
            this.setState({ answer : null, reserved :  null, fetching: false });
        }
    }

    async ignore() { 
        if (this.props.answerId || this.props.id)
            return;
        await this.context.store.dispatch(request({
            path: `/answer/${this.state.answer.id}/ignore/`,
        }));
        this.setState({
            assignedScores: {},
        }); 
          

        if (this.props.answerId || this.props.id)
            this.fetch.bind(this)();
        else{
            this.next.bind(this)();
        }
    }

    async markUnreadable() {
        if (this.props.admin) {
            await this.context.store.dispatch(request({
                path: `/answer/${this.state.answer.id}/`,
                body: {unreadable: true},
                method: 'PATCH',
            }));
        }
        else {
            await this.context.store.dispatch(request({
                path: `/answer/${this.state.answer.id}/mark_unreadable/`,
            }));
        }
        this.setState({
            assignedScores: {},
        });
        this.userSelect = document.body.style.userSelect;
        document.body.style.userSelect = 'none';
        if (this.props.answerId || this.props.id)
            this.fetch.bind(this)();
        else
            this.next.bind(this)();
    }

    async markReadable() {
        await this.context.store.dispatch(request({
            path: `/answer/${this.state.answer.id}/`,
            body: {unreadable: false},
            method: 'PATCH',
        }));
        this.setState({
            assignedScores: {},
        });
        this.userSelect = document.body.style.userSelect;
        document.body.style.userSelect = 'none';
        if (this.props.answerId || this.props.id)
            this.fetch.bind(this)();
        else
            this.next.bind(this)();  
    }

    async save(proccess_need = false) {
        function add(accumulator, a) {
            return accumulator + a;
          }
        debugger;
        var scores = _.map(this.state.assignedScores, _.identity);
        var scoresCount = this.state.answer.scores.length;
        var asignedCount = scores.length;
        if(scoresCount!=asignedCount){
            var remain = scoresCount - asignedCount;
            if(remain > 0){
                alert('باتوجه به اینکه برای جواب ' + scoresCount + ' تا نمره در نظر گرفته شده ، باید ' + remain + ' نمره دیگر هم ثبت کنید ، در'+
                    ' صورتی که دانش آموز جواب صحیح نداده به تعداد بارم ها صفر بزارید'
                );
            }
            else{
                alert('لطفا به تعداد بارم ها آیتم نمره دهید')
            }
            return false;
            
        }
        var newScores = [];
        for(var i = 0 ; i<= scores.length ; i++){
            if(scores[i]!==undefined && scores[i]!==null){
                newScores.push(scores[i]);
            }
        }
        var sc = newScores.map(function(item){return item!==undefined && item!==null ? item.score:0;});
        var sum = sc.reduce(add, 0);
        if(sum > 8 ){
            alert('حداکثر نمره برای این سوال 8 است ، بارم را اصلاح و مجددا نسبت به ذخیره نمره اقدام کنید');
            return false;
        }
        else{
            if (this.props.id) {
                const payload = { 
                    // scores: _.map(this.state.assignedScores, _.identity),
                    scores : newScores,
                    proccess_need : proccess_need 
                };
                await this.context.store.dispatch(request({
                    path: `/result/${this.state.result.id}/`,
                    method: 'PATCH',
                    body: payload,
                }));
                this.setState({
                    assignedScores: {},
                });
                if(this.state.commentId && this.state.commentId > 0){
                    this.changeCommentStatus();
                }
            }
            else {
                const payload = {
                    answer: {id: this.state.answer.id},
                    // scores: _.map(this.state.assignedScores, _.identity),
                    scores : newScores,
                    proccess_need : proccess_need
                };
                await this.context.store.dispatch(request({
                    path: '/result/',
                    method: 'POST',
                    body: payload,
                }));
                this.setState({
                    assignedScores: {},
                });
                if(this.state.commentId && this.state.commentId > 0){
                    this.changeCommentStatus();
                }
            }
            return true;
        }
       
    }


    async white_paper() {
        
        if (this.props.id) {
            const payload = { 
                scores: _.map(this.state.assignedScores, _.identity),
                white_paper : true
            };
            await this.context.store.dispatch(request({
                path: `/result/${this.state.result.id}/`,
                method: 'PATCH',
                body: payload,
            }));
            this.setState({
                assignedScores: {},
            });
        }
        else {
            const payload = {
                answer: {id: this.state.answer.id},
                scores: _.map(this.state.assignedScores, _.identity),
                white_paper : true
            };
            await this.context.store.dispatch(request({
                path: '/result/',
                method: 'POST',
                body: payload,
            }));
            this.setState({
                assignedScores: {},
            });
        }
    }

    render() {  
        if (this.state.fetching)
            return null;
        if (!this.state.answer || !this.state.answer.content)
            return <div
                style={{
                    backgroundColor: styles.infoBackColor,
                    color: styles.infoColor,
                    borderColor: styles.infoBorderColor,
                }}>
                {window.gettext('Nothing remained to be marked for this question!')}
            </div>;
        return <><div>
            <div
                ref='centimeter'
                style={{
                    opacity: '0',
                    top: '0',
                    right: '0',
                    width: '10cm',
                    height: '10cm',
                    position: 'absolute',
                    pointerEvents: 'none',
                }}>
            </div>
            <div style={{float: 'right'}}>
                <div
                    style={{float: 'right', position: this.state.mode === 0 ? 'relative' : 'fixed', zIndex: '1'}}>
                    <div
                        ref='key'
                        style={{
                            width: this.state.answer.width + 'cm',
                            height: (this.state.mode === 0 ? '100%' : 'calc(2.75em*1.2)'),
                            overflow: 'hidden',
                            cursor: 'pointer',
                            border: '.0625em solid black',
                            marginTop: this.state.mode === 0 ? '.5cm' : '0',
                            marginLeft: '.5cm',
                            marginRight: '.5cm',
                            padding: this.state.mode === 0 ? '.5cm' : '0',
                            boxSizing: 'border-box',
                            backgroundColor: 'white',
                            transition: 'margin-top 500ms, height 500ms',
                            fontFamily: 'IRANSans',
                            fontSize: this.state.mode === 0 ? '11pt' : undefined,
                        }}
                        dangerouslySetInnerHTML={this.state.mode === 0
                            ? {__html: this.state.answer.content}
                            : undefined
                        }
                        onClick={() => this.setState({mode: 1 - this.state.mode})}>
                        {this.state.mode === 0
                            ? null
                            : <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    height: '100%',
                                    paddingRight: '.75em',
                                    color: '#9a9a9a',
                                }}>
                                <i className='fa-key fa-lg'></i>
                            </div>
                        }
                    </div>
                    {_.map(
                        _.concat({score: 0, id: null}, _.sortBy(this.state.answer.scores, score => score.top)),
                        (score, index) => <div
                            key={index}
                            style={{
                                position: 'absolute',
                                display: 'flex',
                                top: score.id === null && score.top === null ? undefined : score.id === null && score.top !== null ? score.top + 'px' : this.state.mode === 0
                                ? `calc(${score.top}px - 1.125em + .5cm)`
                                : '.25em',
                                bottom: score.id === null ? '.25em' : undefined,
                                right: score.id === null ? 'calc(100% + .25em)' : this.state.mode === 0
                                ? `calc(${score.right}px - 1.125em + .5cm)`
                                : `calc(${(index - 1) * 2.5}em + .5cm + 2em)`,
                                cursor: '-webkit-grab',
                                color: this.state.assignedScores[index]
                                ? 'rgba(140, 70, 70, .4)'
                                : this.state.mode === 0
                                ? 'rgba(255, 0, 0, .4)'
                                : 'rgba(255, 0, 0, .8)',
                                fontFamily: 'Dast Nevis',
                                fontSize: this.state.mode === 0 ? '1.5rem' : '1.2rem',
                                border: `.125em solid ${this.state.assignedScores[index]
                                ? 'rgba(140, 70, 70, .2)'
                                : this.state.mode === 0
                                ? 'rgba(255, 0, 0, .2)'
                                : 'rgba(255, 0, 0, .6)'}`,
                                borderRadius: '50%',
                                width: '2em',
                                height: '2em',
                                justifyContent: 'center',
                                alignItems: 'center',
                                zIndex: '1',
                                transition: 'top 500ms, right 500ms, width 500ms, height 500ms, font-size 500ms,' +
                                ' color 500ms, borderColor 500ms',
                            }}
                            onMouseDown={event => {
                                const originalNode = event.currentTarget;
                                const originalRect = originalNode.getBoundingClientRect();
                                const node = originalNode.cloneNode(true);
                                event.currentTarget.parentElement.appendChild(node);
                                originalNode.style.color =  'rgba(140, 70, 70, .4)';
                                originalNode.style.borderColor =  'rgba(140, 70, 70, .2)';
                                const transition = node.style.transition;
                                node.style.transition = '';
                                node.style.color =  this.state.mode === 0
                                    ? 'rgba(255, 0, 0, .4)'
                                    : 'rgba(255, 0, 0, .8)';
                                node.style.borderColor =this.state.mode === 0
                                    ? 'rgba(255, 0, 0, .2)'
                                    : 'rgba(255, 0, 0, .6)';
                                node.style.fontSize = '1.5rem';
                                let rect = node.getBoundingClientRect();
                                const parentRect = node.parentElement.getBoundingClientRect();
                                node.style.right = parentRect.width - (
                                    originalRect.left + originalRect.width / 2 - parentRect.left + rect.width / 2
                                ) + 'px';
                                node.style.top = originalRect.top + originalRect.height / 2 -
                                    parentRect.top - rect.height / 2 + 'px';
                                rect = node.getBoundingClientRect();
                                node.style.fontSize = originalNode.style.fontSize;
                                node.getBoundingClientRect();
                                node.style.transition = 'width 200ms, height 200ms, font-size 200ms';
                                node.style.fontSize = '1.5rem';

                                const relatedNodes = this.refs.key.querySelectorAll(
                                    `.score[data-score-id="${score.id}"]`,
                                );
                                const backgrounds = [];
                                _.forEach(relatedNodes, node => {
                                    backgrounds.push(node.style.backgroundColor);
                                    node.style.backgroundColor = 'rgb(255, 100, 100)';
                                });
                                node.style.cursor = '-webkit-grabbing';
                                const width = rect.width;
                                let offsetX = event.clientX - rect.left;
                                let offsetY = event.clientY - rect.top;
                                const mouseDownHandler = event => event.stopPropagation();
                                const mouseMoveHandler = event => {
                                    const rect = node.parentElement.getBoundingClientRect();
                                    const top = (event.clientY - rect.top - offsetY);
                                    const right = (rect.width - (event.clientX - rect.left - offsetX) - width);
                                    node.style.top = top + 'px';
                                    node.style.right = right + 'px';
                                };
                                const mouseUpHandler = event => {
                                    if (
                                        Math.abs(node.getBoundingClientRect().top - rect.top) +
                                        Math.abs(node.getBoundingClientRect().right - rect.right) < 10
                                    ) {
                                        offsetX = rect.width / 2;
                                        offsetY = rect.height / 2;
                                        document.addEventListener('mousedown', mouseDownHandler, true);
                                        return;
                                    }
                                    if (!this.state.assignedScores[index]) {
                                        originalNode.style.color =this.state.mode === 0
                                            ? 'rgba(255, 0, 0, .4)'
                                            : 'rgba(255, 0, 0, .8)';
                                        originalNode.style.borderColor =this.state.mode === 0
                                            ? 'rgba(255, 0, 0, .2)'
                                            : 'rgba(255, 0, 0, .6)';
                                    }
                                    node.style.cursor = '-webkit-grab';
                                    _.forEach(
                                        relatedNodes,
                                        (node, index) => node.style.backgroundColor = backgrounds[index],
                                    );
                                    node.style.transition = transition;
                                    const imageRect = this.refs.image.getBoundingClientRect();
                                    const top = event.clientY;
                                    const left = event.clientX;
                                    if (
                                        top > imageRect.top &&
                                        top + node.clientHeight < imageRect.bottom &&
                                        left > imageRect.left &&
                                        left + node.clientWidth < imageRect.right
                                    ) {
                                        const top = (event.clientY - imageRect.top - offsetY);
                                        const right = (
                                            imageRect.width - (event.clientX - imageRect.left - offsetX) -
                                            width
                                        );
                                        this.refs.image.appendChild(node);
                                        node.style.top = top + 'px';
                                        node.style.right = right + 'px';
                                        const nodeRect = node.getBoundingClientRect();
                                        const containerRect = this.refs.image.getBoundingClientRect();
                                        this.setState(update(this.state, {assignedScores: {
                                            [index > 0 ? index : window.uuidv4()]: {$set: {
                                                top: (
                                                    nodeRect.top - containerRect.top +
                                                    nodeRect.bottom - containerRect.top
                                                ) / 2,
                                                right: containerRect.width - (
                                                    nodeRect.left - containerRect.left +
                                                    nodeRect.right - containerRect.left
                                                ) / 2,
                                                score: score.score,
                                                id: score.id,
                                            }},
                                        }}));
                                    }
                                    node.remove();
                                    document.removeEventListener('mousedown', mouseDownHandler, true);
                                    document.removeEventListener('mousemove', mouseMoveHandler, true);
                                    document.removeEventListener('mouseup', mouseUpHandler, true);
                                };
                                document.addEventListener('mousemove', mouseMoveHandler, true);
                                document.addEventListener('mouseup', mouseUpHandler, true);
                            }}>
                            {score.score.persian(true)}
                        </div>,
                    )}
                </div>
                <div
                    ref='image'
                    style={{
                        position: 'relative',
                        zIndex: '0',
                        float: 'right',
                        marginTop: this.state.mode === 0 ? undefined : '2.5cm',
                    }}>
                    {this.refs.centimeter
                        ? [
                            (this.state.answer.type== 3) ? (this.state.answer.text=="" || this.state.answer.text==null)?null:
                            <div style={{
                                height:(Number.parseFloat(this.state.answer.height) + 1) + 'cm',
                                width: (Number.parseFloat(this.state.answer.width) + 1) + 'cm',
                                border: '2px solid black',
                                }}>{this.state.answer.text}</div>:
                            (this.state.answer.image=="")?null:
                             <img
                                key='answer'
                                src={imageUrl(this.state.answer.image, {
                                    width: (Number.parseFloat(this.state.answer.width) + 1) *
                                    this.refs.centimeter.offsetWidth / 10,
                                    heigth: (Number.parseFloat(this.state.answer.height) + 1) *
                                    this.refs.centimeter.offsetHeight / 10,
                                    type: 'orginal-img',
                                })}
                                style={{
                                    float: 'right',
                                    width: (Number.parseFloat(this.state.answer.width) + 1) + 'cm',
                                    // height: (Number.parseFloat(this.state.answer.height) + 1) + 'cm',
                                }}
                            />,
                            this.state.reserved && this.state.reserved.image!=""
                            ? <img
                                key='reserved'
                                src={imageUrl(this.state.reserved.image, {
                                    width: (Number.parseFloat(this.state.reserved.width) + 1) *
                                    this.refs.centimeter.offsetWidth / 10,
                                    heigth: (Number.parseFloat(this.state.reserved.height) + 1) *
                                    this.refs.centimeter.offsetHeight / 10,
                                    type: 'orginal-img',
                                })}
                                style={{
                                    width: '0',
                                    // height: 0,
                                }}
                            />
                            : null,
                        ]
                        : setTimeout(this.forceUpdate.bind(this), 200) && null
                    }
                    {_.map(this.state.assignedScores, (score, index) =><div
                        key={index}
                        style={{
                            position: 'absolute',
                            display: 'flex',
                            top: `calc(${score?.top}px - 1.125em)`,
                            right: `calc(${score?.right}px - 1.125em)`,
                            cursor: '-webkit-grab',
                            color: 'rgba(255, 0, 0, .7)',
                            fontFamily: 'Dast Nevis',
                            fontSize: '1.5rem',
                            border: '.125em solid rgba(255, 0, 0, .5)',
                            borderRadius: '50%',
                            width: '2em',
                            height: '2em',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: '1',
                        }}
                        onMouseDown={event => {
                            const node = event.currentTarget;
                            const relatedNodes = this.refs.key.querySelectorAll(
                                `.score[data-score-id="${score.id}"]`,
                            );
                            const backgrounds = [];
                            _.forEach(relatedNodes, node => {
                                backgrounds.push(node.style.backgroundColor);
                                node.style.backgroundColor = 'rgb(255, 100, 100)';
                            });
                            node.style.cursor = '-webkit-grabbing';
                            const transition = node.style.transition;
                            node.style.transition = '';
                            const rect = node.getBoundingClientRect();
                            const width = rect.width;
                            let offsetX = event.clientX - rect.left;
                            let offsetY = event.clientY - rect.top;
                            const mouseDownHandler = event => event.stopPropagation();
                            const mouseMoveHandler = event => {
                                const rect = node.parentElement.getBoundingClientRect();
                                const top = (event.clientY - rect.top - offsetY);
                                const right = (rect.width - (event.clientX - rect.left - offsetX) - width);
                                node.style.top = top + 'px';
                                node.style.right = right + 'px';
                            };
                            const mouseUpHandler = event => {
                                if (
                                    Math.abs(node.getBoundingClientRect().top - rect.top) +
                                    Math.abs(node.getBoundingClientRect().right - rect.right) < 10
                                ) {
                                    offsetX = rect.width / 2;
                                    offsetY = rect.height / 2;
                                    document.addEventListener('mousedown', mouseDownHandler, true);
                                    return;
                                }
                                node.style.cursor = '-webkit-grab';
                                _.forEach(
                                    relatedNodes,
                                    (node, index) => node.style.backgroundColor = backgrounds[index],
                                );
                                node.style.transition = transition;
                                const imageRect = this.refs.image.getBoundingClientRect();
                                const top = event.clientY;
                                const left = event.clientX;
                                if (
                                    top > imageRect.top &&
                                    top + node.clientHeight < imageRect.bottom &&
                                    left > imageRect.left &&
                                    left + node.clientWidth < imageRect.right
                                ) {
                                    const top = (event.clientY - imageRect.top - offsetY);
                                    const right = (
                                        imageRect.width - (event.clientX - imageRect.left - offsetX) -
                                        width
                                    );
                                    this.refs.image.appendChild(node);
                                    node.style.top = top + 'px';
                                    node.style.right = right + 'px';
                                    const nodeRect = node.getBoundingClientRect();
                                    const containerRect = this.refs.image.getBoundingClientRect();
                                    this.setState(update(this.state, {assignedScores: {[index]: {$set: {
                                        top: (
                                            nodeRect.top - containerRect.top +
                                            nodeRect.bottom - containerRect.top
                                        ) / 2,
                                        right: containerRect.width - (
                                            nodeRect.left - containerRect.left +
                                            nodeRect.right - containerRect.left
                                        ) / 2,
                                        score: score.score,
                                        id: score.id,
                                    }}}}));
                                }
                                else
                                    this.setState(update(this.state, {assignedScores: {
                                        $apply: scores => _.pickBy(scores, (__, index_) => index != index_),
                                    }}));
                                document.removeEventListener('mousedown', mouseDownHandler, true);
                                document.removeEventListener('mousemove', mouseMoveHandler, true);
                                document.removeEventListener('mouseup', mouseUpHandler, true);
                            };
                            document.addEventListener('mousemove', mouseMoveHandler, true);
                            document.addEventListener('mouseup', mouseUpHandler, true);
                        }}>
                        {score?.score?.persian(true)}
                    </div>)}
                </div>
            </div>
            <div style={{float: 'left', direction: 'ltr'}}>
                <div style={{position: 'fixed', direction: 'rtl'}}> 
                    <div>
                        {this.state.answer.note}
                    </div> 
                    {this.state.all_resutl?.res.map((element) => {
                        return <span>
                             <button
                        style={{...styles.lastmark_defaultButton}} 
                        onClick={() => {
                            this.setOldScore.bind(this)(element.scores,element.id); 
                        }}>
                        
                        {"تصحیح " + element.mark_number.persian(true) + ": " + element.marker + 
                         " , " +element.mark.persian(true) + " نمره"}

                        {this.state.seleced_id === element.id?<i className='fa fa-check'></i>:null} 
                         </button>          
                         </span>
                    })}
                    <button
                        style={{...styles.mark_defaultButton}}
                        disabled={_.size(this.state.assignedScores) === 0}
                        onClick={async () => {
                            var res = await this.save.bind(this)();
                            if (res) {                                
                              this.next.bind(this)();
                            }
                        }}>
                        {window.gettext('Submit Score')}
                    </button>                                      
                    <button
                        style={{...styles.mark_highButton}} 
                        onClick={async () => {
                            var res = await this.save.bind(this)();
                            if (res) {                                
                              this.next.bind(this)();
                            }
                        }}>
                          ثبت نمره و بررسی مجدد 
                    </button> 
                    <button
                        style={{...styles.mark_button}} 
                        onClick={async () => {
                            await this.white_paper.bind(this)();
                            this.next.bind(this)();
                        }}>
                           برگه سفید است
                    </button> 
                    <button
                        style={{...styles.mark_orange_button}}
                        onClick={async () => {
                            await this.ignore.bind(this)();
                            this.next.bind(this)();
                        }}>
                        {window.gettext('Ignore')}
                    </button>   
                    {this.state.answer.unreadable
                        ? this.props.admin
                        ? <button
                            style={{...styles.mark_errorButton }}
                            onClick={async () => {
                                await this.markReadable.bind(this)();
                                this.next.bind(this)();
                            }}>
                            {window.gettext('Readable')}
                        </button>
                        : null
                        : <button
                            style={{...styles.mark_errorButton }}
                            onClick={async () => {
                                await this.markUnreadable.bind(this)();
                                this.next.bind(this)();
                            }}>
                            {window.gettext('Unreadable')}
                        </button>
                    }
                    {
                        this.state.comment ? 
                            <div style={{marginTop : "10px",padding:'10px',border : "3px solid #ebebeb",backgroundColor:"#f6f6f6",
                            maxWidth: "350px",maxHeight:" 350px",overflowY: "scroll"}}>
                                <span>{"متن اعتراض : "}</span>
                                <br/>
                                {this.state.comment}
                            </div> : null
                    }   
                </div>  
            </div>
        </div></>;
    }
}
